import { Button, Statistic, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CampaignList } from '../../../apis/Admin/Campaigns/CampaignList';
import { useGlobalState } from '../../../store/state';
import CurrencyIcon from '../../Common/CurrencyIcon';
import './HomeTabledComponents.styles.scss';

const CampaignClosedComponent = ({ className }) => {
  const [user] = useGlobalState('user');
  const [camps, setCamps] = useState({
    data: [],
  });
  const dataSource = [
    {
      key: '1',
      name: '10K run free event',
      id: 'fdgffdgffdg34dfgdfdfgsdferd',
      earnings: 75000,
      payouts: 47000,
    },
    {
      key: '2',
      name: 'Magic Block camps',
      id: 'fghfdghrtyrtyhghffgsdferd',
      earnings: 15000,
      payouts: 7000,
    },
    {
      key: '3',
      name: 'Superman bixcxs3 ',
      id: 'fghfdghrtyrtyhghffgsdferd',
      earnings: 155000,
      payouts: 102500,
    },
  ];

  const columns = [
    {
      title: 'Campaign Name',
      dataIndex: 'name',
      key: 'name',
      render: (value, rest) => (
        <div className="table_name_field">{value}<span>{rest.id}</span></div>
      ),
    },
    // {
    //   title: 'status',
    // //   dataIndex: 'age',
    //   key: 'status',
    // },
    {
      width: 90,
      title: 'Flynt Earnings',
      dataIndex: 'earnings',
      key: 'earnings',
      render: (value) =>(
        <>{CurrencyIcon()}<Statistic value={value}
          className="custom_number_format"/></>
      ),
    },
    {
      width: 90,
      title: 'Payable to Influencers',
      dataIndex: 'payouts',
      key: 'payouts',
      render: (value) =>(
        <>{CurrencyIcon()}<Statistic value={value}
          className="custom_number_format"/></>
      ),
    },
    {
      width: 85,
      title: 'Action',
      //   dataIndex: 'action',
      key: 'action',
      render: (value) =>(
        <a href="#"
          className="common_button outlined my-1 d-inline-block py-1">View</a>
      ),
    },
  ];

  // @note: common function for get Campaigns
  const getCampaignList = (status, page, limit) =>{
    setCamps({
      ...camps,
      query: '',
      // searching:false,
      filter: status,
      data: [],
    });
    CampaignList(user.accessToken, { status, page, limit }).then(({ status, response })=>{
      console.log('fetched camps', response);
      if (status === 200) {
        setCamps({
          data: response.campaigns.map((camp)=>{
            return {
              key: camp.id,
              name: camp.name || 'N/A',
              id: camp.id || 'N/A',
              earnings: camp.earnings || 'N/A',
              payouts: camp.payouts || 'N/A',
            };
          }),
        });
      }
    });
  };

  useEffect(()=>{
    getCampaignList('rejected', 1, 3);
  }, []);

  return (
    <div className={`${className}`}>
      <div className="common_card admin_stats_tabled p-3 h-100">
        <div className="admin_stats_tabled_top d-md-flex d-flex-wrap">
          <div className="col-md-7 p-0">
            <h4 className="mb-0">Completed Campaigns</h4>
            <p className="m-0">Total {camps.data.length} Campaign{camps.data.length > 1 ? 's':''} completed</p>
          </div>
          <div className="col-md-5 text-right p-0">
            <Link to="/admin/dashboard/campaigns"
              className="common_button">View All</Link>
          </div>
        </div>
        <div className="admin_stats_tabled_data pt-4">
          <Table className="tiny_table"
            dataSource={camps.data}
            columns={columns}
            pagination={false} />
        </div>
      </div>
    </div>
  );
};

export default CampaignClosedComponent;
